import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExpiredSessionComponent } from '@nx-fe/expired-session';
import { CoreModule } from 'sspcore/core.module';
import { AuthGuard, RedirectGuard } from 'sspcore/guards';
import { PageLayoutComponent } from './modules/core/components/pagelayout/pagelayout.component';
import { EnrollPageComponent } from './modules/enroll/components/enroll-page/enroll-page.component';
import { LoginPageComponent } from './modules/login/components/login-page/login-page.component';
import { TicketNotFoundComponent } from './modules/ticket/components/not-found/not-found.component';
import { TicketContentComponent } from './modules/ticket/components/ticket-content/ticket-content.component';
import { TicketPageComponent } from './modules/ticket/components/ticket-page/ticket-page.component';
import { ViewDeviceDetailsComponent } from './modules/devices/view-device-details/view-device-details.component';
import { LocationComponent } from './modules/devices/view-device-details/location/location.component';
import { OverviewComponent } from './modules/devices/view-device-details/overview/overview.component';
import { DirtyCheckGuard } from './services/can-deactivate-guard.service';

const routes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent,
    canActivate: [RedirectGuard]
  },
  {
    path: 'home',
    component: PageLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: TicketPageComponent,
        children: [
          {
            path: 'create',
            component: TicketContentComponent,
            canDeactivate: [DirtyCheckGuard],
          },
          {
            path: 'device/:id',
            component: ViewDeviceDetailsComponent,
            children: [
              {
                path: 'overview',
                component: OverviewComponent,
              },
              {
                path: 'location',
                component: LocationComponent,
              },
            ],
          },
          {
            path: 'ticket/:id',
            component: TicketContentComponent,
          },
          {
            path: 'ticket/:id/:submit',
            component: TicketContentComponent,
          },
          {
            path: '',
            component: TicketNotFoundComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'expiredSession',
    component: ExpiredSessionComponent,
    pathMatch: 'full',
  },
  {
    path: 'enroll',
    component: PageLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '**',
        component: EnrollPageComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];

@NgModule({
  imports: [CoreModule, RouterModule.forRoot(routes, { enableTracing: true })],
  providers: [AuthGuard, RedirectGuard],
  exports: [RouterModule],
})
export class AppRoutingModule {}
